import { Collapse, Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
const { Panel } = Collapse;

const CommentForVendor = ({ comment }) => {
    return <Collapse defaultActiveKey={['1']} expandIconPosition="end">
        <Panel header='Comment From Vendor' key="1">
            <Input disabled value={comment}></Input>
        </Panel>
    </Collapse>
}

CommentForVendor.propTypes = {
    comment: PropTypes.string,
}

export default CommentForVendor